export enum StrikeZoneLocation {
  Front = 'Front',
  Middle = 'Middle',
  Back = 'Back',
}
